import React, { useState, useLayoutEffect, useRef, Dispatch, SetStateAction } from 'react';
import { useGetFrozenCount } from '../utils/getFrozenCount';
import TuiGrid from './Table/TuiGrid';
import TuiGridWrapper from './Table/TuiGridWrapper';

type Props = {
  rowKey?: string;
  tableState: TableState[];
  columns: Columns[];
  listCount: number;
  setExcelBtn?: Dispatch<SetStateAction<boolean>>;
  excelBtn?: boolean;
  onClickRow?: (rowData: any) => Promise<void>;
  fileName?: string;
  pageNum?: number;
  gridId?: string;
};

type TableState = { dvName: string; dvNo: string; checkTime: string; avgMq: number; minMq: string };
type Columns = { align: string; filter: string; header: string; minWidth: number; name: string; sortable: boolean };

const TuiGridTable: React.FC<Props> = ({ rowKey, tableState, columns, listCount, setExcelBtn, excelBtn, onClickRow, fileName, pageNum, gridId }) => {
  const componentRef = useRef<HTMLDivElement>(null);
  const [containerHeight, setContainerHeight] = useState<number>(0);
  const frozenCount = useGetFrozenCount();

  useLayoutEffect(() => {
    const tuiHeightFn = () => {
      if (componentRef.current) {
        const height = componentRef.current.offsetHeight;
        if (height > 0) {
          setContainerHeight(height);
        }
      }
    };

    tuiHeightFn();
    window.addEventListener('resize', tuiHeightFn);

    return () => window.removeEventListener('resize', tuiHeightFn);
  }, [tableState]);

  return (
    <TuiGridWrapper componentRef={componentRef}>
      {tableState.length !== 0 && (
        <TuiGrid
          data={tableState}
          columns={columns}
          perPage={listCount}
          excelBtn={excelBtn}
          setExcelBtn={setExcelBtn}
          usePagenation
          onClickRow={onClickRow}
          scrollX
          height={containerHeight}
          frozenCount={frozenCount}
          fileName={fileName}
          rowKey={rowKey}
          pageNum={pageNum}
          gridId={gridId}
        />
      )}
    </TuiGridWrapper>
  );
};

export default React.memo(TuiGridTable);
